import React, { useEffect, useState } from "react";
import {
  Form,
  Input,
  DatePicker,
  Checkbox,
  Radio,
  Row,
  Col,
  Button,
  Space,
  message,
  Select,
} from "antd";
import { IoClose, IoPrintOutline, IoSaveOutline } from "react-icons/io5";
import { request } from "../../share/request";
import moment from "moment";

const BloodTestForm = ({ item_id, donor_id, update_form, closeFormDiag }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    console.log("Update form data:", item_id);
    console.log("🧪 donor_type from update_form:", update_form.donor_type);
    console.log("✅ Is array?", Array.isArray(update_form.donor_type));

    if (!item_id) {
      // Reset form to default empty values
      form.setFieldsValue({
        donator_code: "",
        weight: "",
        hemoglobin: "",
        blood_pressure: "",
        hematocrit: "",
        pulse: "",
        blood_group: "",
        rhesus: "",
        donor_type: [],
        donation_place: "",
        location_code: "",
        blood_bag_number: "",
        donation_date: null,
        bag_type: "",
        diagnosis: "",
        ml_amount: "",
        temporary_ban_date: null,
        reason: [],
        other_issues: "",
      });
      return;
    }

    if (update_form) {
      // Populate form with update_form data
      form.setFieldsValue({
        donator_code: update_form.donator_code || "",
        weight: update_form.weight_kg || "",
        hemoglobin: update_form.hemoglobin || "",
        blood_pressure: `${update_form.blood_pressure_systolic || ""}/${
          update_form.blood_pressure_diastolic || ""
        }`,
        hematocrit: update_form.hematocrit || "",
        pulse: update_form.pulse_rate || "",
        blood_group: update_form.blood_group_abo || "",
        rhesus: update_form.rhesus || "",

        donation_place: update_form.donation_place || "",
        location_code: update_form.place_code || "",
        blood_bag_number: update_form.blood_bag_code || "",
        donation_date:
          update_form.donation_date &&
          moment(update_form.donation_date, "YYYY-MM-DD"),
        bag_type: update_form.blood_bag_type || "",
        diagnosis: update_form.diagnosis_result || "",
        ml_amount: update_form.blood_amount_ml || "",
        temporary_ban_date:
          update_form.prohibited_until_date &&
          moment(update_form.prohibited_until_date, "YYYY-MM-DD"),

        other_issues: update_form.other_issues || "",
      });
    }
  }, [item_id, update_form]);
  useEffect(() => {
    if (update_form) {
      let donorType = update_form.donor_type;
      let rejectionReason = update_form.rejection_reason;

      // Handle donorType parsing
      if (typeof donorType === "string") {
        try {
          donorType = JSON.parse(donorType);
        } catch (e) {
          console.error("❌ Failed to parse donor_type:", donorType);
          donorType = [];
        }
      }

      // Handle rejectionReason double-encoded
      if (typeof rejectionReason === "string") {
        try {
          rejectionReason = JSON.parse(rejectionReason);
        } catch (e) {
          console.error(
            "❌ Failed to parse rejection_reason:",
            rejectionReason
          );
          rejectionReason = [];
        }
      }

      // Set form values
      form.setFieldsValue({
        donor_type: donorType,
        reason: rejectionReason,
      });

      console.log("✅ donor_type:", donorType);
      console.log("✅ rejection_reason:", rejectionReason);
    }
  }, [form, update_form]);

  const onHandleSave = async () => {
    setLoading(true);
    try {
      const values = form.getFieldsValue();

      // Parse blood_pressure (expecting format "120/80")
      let systolic = null;
      let diastolic = null;
      if (values.blood_pressure) {
        const parts = values.blood_pressure.split("/");
        systolic = parts[0] ? parts[0].trim() : null;
        diastolic = parts[1] ? parts[1].trim() : null;
      }

      // Format dates to 'YYYY-MM-DD' strings
      const donationDateStr = values.donation_date
        ? values.donation_date.format("YYYY-MM-DD")
        : null;
      const tempBanDateStr = values.temporary_ban_date
        ? values.temporary_ban_date.format("YYYY-MM-DD")
        : null;

      const data = {
        id: item_id, // Use donor_id if available, otherwise null
        donor_id: donor_id, // or get dynamically if needed
        donator_code: values.donator_code || null,
        weight_kg: values.weight || null,
        hemoglobin: values.hemoglobin || null,
        blood_pressure_systolic: systolic,
        blood_pressure_diastolic: diastolic,
        hematocrit: values.hematocrit || null,
        pulse_rate: values.pulse || null,
        blood_group_abo: values.blood_group || null,
        rhesus: values.rhesus || null,
        donor_type: values.donor_type || [], // keep as array
        donation_place: values.donation_place || null,
        place_code: values.location_code || null,
        blood_bag_code: values.blood_bag_number || null,
        donation_date: donationDateStr,
        blood_bag_type: values.bag_type || null,
        diagnosis_result: values.diagnosis || null,
        diagnosis_date: donationDateStr, // Or another field if you want
        blood_amount_ml: values.ml_amount || null,
        prohibited_until_date: tempBanDateStr,
        rejection_reason: values.reason || [], // keep as array
        other_issues: values.other_issues || null,
        doctor_signature: values.doctor_signature || null, // if added later
      };

      console.log("Data to be sent:", data);

      //   Example sending data to backend
      const response = await request(
        "donatordiagnosis",
        item_id === null ? "post" : "put",
        data
      );
      if (response) {
        message.success("Data saved successfully!");
        form.resetFields();
      } else {
        message.error("Failed to save data.");
      }
    } catch (error) {
      console.error("Save failed:", error);
      if (error.response?.data?.message) {
        message.error(error.response.data.message);
      } else if (error.name === "ValidationError") {
        message.warning("Please complete all required fields.");
      } else {
        message.error("An unexpected error occurred.");
      }
    } finally {
      setLoading(false);
    }
  };
  const onHandleClose = () => {
    closeFormDiag();
  };
  useEffect(() => {
    if (update_form && Array.isArray(update_form.donor_type)) {
      console.log("✅ donor type from update_form:", update_form.donor_type);
      form.setFieldsValue({
        donor_type: update_form.donor_type,
      });
    }
  }, [update_form, form]);

  return (
    <Form layout="vertical" form={form}>
      <Row gutter={16}>
        <Col span={6}>
          <Form.Item label="• លេខកូដផ្តល់ឈាម" name="donator_code">
            <Input />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item label="• ទម្ងន់ (គក្រ)" name="weight">
            <Input />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item label="• អេម៉ូក្លូប៊ីន (ក្រាម/១០០មល)" name="hemoglobin">
            <Input />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item label="• សម្ពាធឈាម (mmHg)" name="blood_pressure">
            <Input placeholder="Sys/Dia" />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={16}>
        <Col span={12}>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item label="• អេម៉ាតូគ្រីត (%)" name="hematocrit">
                <Input />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label="• ជីពចរ (ក្នុង១នាទី)" name="pulse">
                <Input />
              </Form.Item>
            </Col>
          </Row>
        </Col>
        <Col span={12}>
          <Row gutter={16}>
            <Col span={12}>
         <Form.Item label="• ក្រុមឈាម ABO" name="blood_group">
  <Select style={{height:40}}
    showSearch
    placeholder="ជ្រើសរើស​ក្រុម​ឈាម"
    optionFilterProp="label"
    options={[
      { value: "បញ្ហាសុខភាព", label: "បញ្ហាសុខភាព" },
      { value: "A", label: "A" },
      { value: "B", label: "B" },
      { value: "O", label: "O" },
      { value: "AB", label: "AB" },
      { value: "A+", label: "A+" },
      { value: "B+", label: "B+" },
      { value: "O+", label: "O+" },
      { value: "AB+", label: "AB+" },
       { value: "N/A", label: "N/A" },
    ]}
  />
</Form.Item>

            </Col>
            <Col span={12}>
              <Form.Item label="រ៉េស៊ីស (RhD)" name="rhesus">
                <Input />
              </Form.Item>
            </Col>
          </Row>
        </Col>
      </Row>
      <Row gutter={16}>
        <Col span={12}>
          <Form.Item label="• ប្រភេទអ្នកបរិច្ចាគឈាម" name="donor_type">
            <Checkbox.Group>
              <Checkbox value="SD">SD</Checkbox>
              <Checkbox value="cSD">cSD</Checkbox>
              <Checkbox value="ED">ED</Checkbox>
              <Checkbox value="RD">RD</Checkbox>
            </Checkbox.Group>
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item label="• ប្រភេទស្បោងឈាម" name="bag_type">
            <Radio.Group>
              <Radio value="single">ស្បោងទោល</Radio>
              <Radio value="double">ស្បោងភ្លោះ</Radio>
              <Radio value="triple">ស្បោងភ្លោះ៣</Radio>
            </Radio.Group>
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={16}>
        <Col span={6}>
          <Form.Item label="• ទីកន្លែងបរិច្ចាគឈាម" name="donation_place">
            <Input />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item label="• លេខកូដកន្លែង" name="location_code">
            <Input />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item label="• ថ្ងៃ ខែ ឆ្នាំ បរិច្ចាគឈាម" name="donation_date">
            <DatePicker format="DD/MM/YYYY" />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item label="• លេខស្បោងឈាម" name="blood_bag_number">
            <Input />
          </Form.Item>
        </Col>
      </Row>

      <Form.Item
        label="• ការវិនិច្ឆ័យ"
        name="diagnosis"
        style={{ backgroundColor: "#1673ff15", padding: "10px" }}
      >
        <Radio.Group style={{ gap: 8 }}>
          <Radio value="allowed">
            <div style={{ display: "flex", alignItems: "center" }}>
              <span>អនុញ្ញាតផ្ដល់ឈាម - ចំណុះឈាមត្រូវបូម(ml):</span>
              <Form.Item name="ml_amount" style={{ margin: 0, marginLeft: 8 }}>
                <Input style={{ width: 120 }} />
              </Form.Item>
            </div>
          </Radio>

          <Radio value="temporary_ban">
            <div style={{ display: "flex", alignItems: "center" }}>
              <span>ហាមផ្ដល់ឈាមមួយរយៈរហូតដល់ថ្ងៃទី:</span>
              <Form.Item
                name="temporary_ban_date"
                style={{ margin: 0, marginLeft: 8 }}
              >
                <DatePicker format="DD/MM/YYYY" />
              </Form.Item>
            </div>
          </Radio>

          <Radio value="permanent_ban">ហាមផ្ដល់ឈាមជារៀងរហូត</Radio>
        </Radio.Group>
      </Form.Item>

      <Form.Item label="• មូលហេតុ" name="reason">
        <Checkbox.Group>
          <Checkbox value="ck_hemoglobin">
            អេម៉ូក្លូប៊ីន / អេម៉ាតូគ្រីត
          </Checkbox>
          <Checkbox value="ck_pressure">សម្ពាធឈាម</Checkbox>
          <Checkbox value="ck_weight">ទម្ងន់</Checkbox>
          <Checkbox value="ck_history">ប្រវត្តិជំងឺ</Checkbox>
          <Checkbox value="ck_status">ស្ថានភាពប្រឈមមុខ</Checkbox>
          <Checkbox value="ck_age">អាយុ</Checkbox>
          <Checkbox value="ck_early">មុនកាលកំណត់</Checkbox>
          <Checkbox value="ck_other">ផ្សេងទៀត</Checkbox>
        </Checkbox.Group>
      </Form.Item>

      <Row gutter={16}>
        <Col span={12}>
          <Form.Item label="• បញ្ហាផ្សេងៗ" name="other_issues">
            <Input.TextArea rows={2} />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Row gutter={16}>
            <Space style={{ marginTop: "40px", marginLeft: "50px" }}>
              <Form.Item>
                <Button
                  onClick={onHandleSave}
                  style={{ width: "100px" }}
                  type="primary"
                  htmlType="submit"
                  loading={loading}
                  block
                  icon={<IoSaveOutline />}
                >
                  រក្សាទុក
                </Button>
              </Form.Item>

              <Form.Item>
                <Button
                  style={{ width: "100px" }}
                  type="default"
                  htmlType="button"
                  block
                  icon={<IoPrintOutline />}
                >
                  បោះពុម្ព
                </Button>
              </Form.Item>

              <Form.Item>
                <Button
                  style={{ width: "100px" }}
                  danger
                  type="default"
                  htmlType="button"
                  onClick={onHandleClose}
                  block
                  icon={<IoClose />}
                >
                  បោះបង់
                </Button>
              </Form.Item>
            </Space>
          </Row>
          <Col span={12}></Col>
        </Col>
      </Row>
    </Form>
  );
};

export default BloodTestForm;
